import { render, staticRenderFns } from "./todayEvaluation.vue?vue&type=template&id=4223844e&scoped=true"
import script from "./todayEvaluation.vue?vue&type=script&lang=js"
export * from "./todayEvaluation.vue?vue&type=script&lang=js"
import style0 from "./todayEvaluation.vue?vue&type=style&index=0&id=4223844e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223844e",
  null
  
)

export default component.exports